import { render, staticRenderFns } from "./father.vue?vue&type=template&id=404c12ae&scoped=true"
import script from "./father.vue?vue&type=script&lang=js"
export * from "./father.vue?vue&type=script&lang=js"
import style0 from "./father.vue?vue&type=style&index=0&id=404c12ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c12ae",
  null
  
)

export default component.exports